import React, { createContext, useEffect, useState } from "react"
import styled from "styled-components"
import Stage0 from "@/components/Menu/Mobile/Stages/Stage0"
import Stage1 from "@/components/Menu/Mobile/Stages/Stage1"
import useCustomContext from "@/hooks/useCustomContext"
import { useRouter } from "next/router"
import { useSelector } from "react-redux"

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	overflow-y: auto;
`
const Stage = ({ index = 0 }) => {
	switch (index) {
		case 0:
			return <Stage0 />
		case 1:
			return <Stage1 />
		default:
			return <Stage0 />
	}
}

const INIT_CONTEXT = {
	stage: 0,
	item: {},
	items: [],
	setStage: () => {},
	setItem: () => {},
}

const StageContext = createContext(INIT_CONTEXT)

const Stages = ({ data }) => {
	const [stage, setStage] = useState(0)
	const [item, setItem] = useState({})
	const isMenuOpen = useSelector((state) => state.menu.open)
	const { asPath } = useRouter()

	useEffect(() => {
		return () => {
			setStage(INIT_CONTEXT.stage)
			setItem(INIT_CONTEXT.item)
		}
	}, [asPath, isMenuOpen])

	return (
		<StageContext.Provider
			value={{
				stage,
				setStage,
				item,
				setItem,
				items: data,
			}}
		>
			<Wrapper>
				<Stage index={stage} />
			</Wrapper>
		</StageContext.Provider>
	)
}

export function useStageContext(selector = undefined) {
	return useCustomContext(StageContext, selector)
}

export default Stages
